import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { breakpointValues } from '@modernhealth/vital-foundation';
import { useLocation } from 'react-router';

const Wrapper = styled.div({
  width: '100%',
  maxWidth: breakpointValues.xl,
  margin: '0 auto',
  padding: 20,
  paddingBottom: 50,
  minHeight: '100vh',
});

export const ScreenWrapper: React.FC = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <Wrapper>{children}</Wrapper>;
};
